<template>
  <div>
    <!-- ACTION BAR -->
    <el-row>
      <el-col :span="24">
        <el-card shadow="never" style="height: 100%;">
          <div class="row">
            <div class="col-6">
              <el-button type="warning" round icon="el-icon-plus"
                @click="dialogs.create.show = true">
                新增印表機
              </el-button>
              <!-- <el-upload ref="upload" action="" accept=".xls,.xlsx,.csv" class="d-inline ml-2">
                <el-button slot="trigger" type="info" round icon="el-icon-plus" @click="uploadBatch" :disabled="true">
                  匯入／批次新增
                </el-button>
              </el-upload> -->
            </div>

            <div class="col-3"></div>
            <div class="col-3 d-flex justify-content-end">
              <el-input v-model="filters[0].value" placeholder="（以序號或名稱搜尋）"
                width="180px" class="pr-2">
              </el-input>
              <el-button type="default" circle icon="el-icon-refresh" title="重新整理"
                @click="fetchPrinters"></el-button>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <br>

    <!-- LIST OF PRINTERS -->
    <data-tables :data="printers" :filters="filters"
      :pagination-props="{pageSizes: [10, 20, 50]}">

      <el-table-column prop="sn" label="序號" sortable="custom"></el-table-column>
      <el-table-column prop="status" label="狀態" width="108" align="center" sortable="custom">
        <div slot-scope="{row}">
          <font-awesome-icon color="firebrick" icon="circle" v-if="row.status === 0"/>
          <font-awesome-icon color="green" icon="signal" v-if="row.status === 1"/>
        </div>
      </el-table-column>

      <el-table-column prop="name" label="名稱" width="240" sortable="custom">
        <div slot-scope="{row}" class="d-flex align-items-center">
          <el-input placeholder="裝置名稱" v-model="editablePrinter.name" size="mini"
            v-if="editables[row.did] === true"></el-input>
          <span v-else>{{row.name}}</span>
        </div>
      </el-table-column>
      
      <el-table-column prop="shop_name" label="綁定店家" width="320" sortable="custom">
        <div slot-scope="{row}" class="d-flex justify-content-between align-items-center">
          <el-autocomplete v-if="editables[row.did] === true" v-model="editablePrinter.shop_name"
            :fetch-suggestions="suggestShops" placeholder="（請選擇店家）" size="mini" popper-class="shop-select-autocomplete"
            @select="onShopSelectionUpdated" @change="onShopSelectionTextChanged">
          </el-autocomplete>
          <span v-else-if="row.shop_name">{{row.shop_name}}&nbsp;<span style="color:#999999;font-size:small;">{{ row.shop_id }}</span></span>
        </div>
      </el-table-column>

      <el-table-column prop="times" label="列印次數" width="84" align="center">
        <div slot-scope="{row}" class="d-flex justify-content-center align-items-center">
          <el-input type="number" v-model="editablePrinter.times" size="mini"
            v-if="editables[row.did] === true"></el-input>
          <span v-else>{{row.times}}</span>
        </div>
      </el-table-column>

      <el-table-column prop="Actions" label="" min-width="240">
        <div slot-scope="{row}">
          <el-button type="warning" icon="el-icon-edit-outline" circle size="small" v-if="!editables[row.did]"
              @click="toggleEditable(row)" title="編輯"></el-button>
          <el-button type="danger" icon="el-icon-check" circle size="small" v-if="editables[row.did]"
            @click="updatePrinter(row)" title="完成編輯"></el-button>
          
          <el-button type="danger" icon="el-icon-close" circle size="small" v-if="editables[row.did]"
            @click="toggleEditable(row, false)" title="取消編輯"></el-button>
          <el-button type="danger" icon="el-icon-unlock" circle size="small" v-if="editables[row.did]"
            @click="unbindPrinter(row)" title="解除綁定"></el-button>
          <el-button type="danger" icon="el-icon-delete" circle size="small" v-if="editables[row.did]"
            @click="deletePrinter(row)" title="刪除此印表機"></el-button>

          <!-- <el-dropdown @command="setSound">
            <el-button type="info" class="el-dropdown-link" icon="el-icon-bell" circle size="small" title="設定提示音"></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="row.did + ':mute'">靜音</el-dropdown-item>
              <el-dropdown-item :command="row.did + ':didi'">滴滴聲</el-dropdown-item>
              <el-dropdown-item :command="row.did + ':small'">人聲（小）</el-dropdown-item>
              <el-dropdown-item :command="row.did + ':medium'">人聲（中）</el-dropdown-item>
              <el-dropdown-item :command="row.did + ':large'">人聲（大）</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
          <el-button type="info" icon="el-icon-bell" circle size="small"
            @click="showSoundSetting(row)" title="設定提示音"></el-button>

          <el-button type="danger" icon="el-icon-document-delete" circle size="small"
            @click="purgePrinterQueue(row)" title="清空列印佇列"></el-button>
          
          <el-button type="primary" icon="el-icon-info" circle size="small"
            @click="showInfo(row)" title="更多資訊"></el-button>

          <el-button type="danger" icon="el-icon-copy-document" circle size="small" 
            @click="copyToShop(row)" title="複製印表機"></el-button>
        </div>
      </el-table-column>
    </data-tables>

    <!-- CREATE DIALOG -->
    <el-dialog title="新增印表機" :visible.sync="dialogs.create.show">
      <el-form :model="dialogs.create.model" label-width="84px">
        <el-form-item label="序號">
          <el-input v-model="dialogs.create.model.sn"></el-input>
        </el-form-item>
        <el-form-item label="名稱">
          <el-input v-model="dialogs.create.model.name"></el-input>
        </el-form-item>
        <el-form-item label="密鑰">
          <el-input v-model="dialogs.create.model.secret"></el-input>
        </el-form-item>
        <el-form-item label="伺服器">
          <el-select v-model="dialogs.create.model.server" size="mini">
            <el-option label="IIOT" value="iiot"></el-option>
            <el-option label="Feieyun" value="feieyun"></el-option>
            <el-option label="Qrcall" value="qrcall"></el-option>
            <el-option label="Qc_v2" value="qc_v2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="列印次數">
          <el-input type="number" v-model="dialogs.create.model.times"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogs.create.show = false">取消</el-button>
        <el-button type="danger" @click="createPrinter">確認新增</el-button>
      </span>
    </el-dialog>

    <!-- INFO DIALOG -->
    <el-dialog :title="'印表機資訊｜' + dialogs.info.printer.name" :visible.sync="dialogs.info.show">
      <div class="w-100 d-flex justify-content-center">
        <img :src="dialogs.info.printer.qrCodeUrl" class="img-fluid">
      </div>
      <br>
      <el-table :data="infoTable" :show-header="false">
        <el-table-column label="Key" prop="key"></el-table-column>
        <el-table-column label="Val" prop="val"></el-table-column>
      </el-table>
    </el-dialog>

    <!-- SOUND SETTING DIALOG -->
    <el-dialog :title="'提示音效設定｜' + dialogs.sound.printer.name" :visible.sync="dialogs.sound.show">
      <el-form :model="dialogs.sound.model" label-width="84px">
        <el-form-item label="語言">
          <el-select v-model="dialogs.sound.model.type" size="mini">
            <el-option label="預設" :value="0"></el-option>
            <el-option label="國語" :value="1"></el-option>
            <el-option label="台語" :value="2"></el-option>
            <el-option label="廣東話" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="類型">
          <el-select v-model="dialogs.sound.model.volume" size="mini">
            <el-option label="靜音" value="mute"></el-option>
            <el-option label="滴滴聲" value="didi"></el-option>
            <el-option label="人聲（小）" value="small"></el-option>
            <el-option label="人聲（中）" value="medium"></el-option>
            <el-option label="人聲（大）" value="large"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogs.sound.show = false">取消</el-button>
        <el-button type="warning" @click="setSound">確認</el-button>
      </span>
    </el-dialog>

    <!-- FILE UPDATE TRIGGER -->
    <!-- <input type="file" ref="file-upload-trigger" class="d-none"> -->
  </div>
</template>

<script>
import axios from 'axios';

import {
  getPrinters, getPrinter,
  createPrinter, updatePrinter, deletePrinter, purgePrinterQueue,
  unbindPrinter,
  setPrinterSound
} from './printer-apis';

import { library } from "@fortawesome/fontawesome-svg-core";
import { faSignal, faCircle, faPen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faSignal, faCircle, faPen);

import { DataTables } from "vue-data-tables";

export default {
  components: {
    DataTables
  },

  mounted() {
    this.fetchPrinters();
    this.fetchShops();
  },

  methods: {
    fetchPrinters() {
      getPrinters().then(response => {
        console.log(`Got printers`, response.data);
        this.printers = response.data;
        this.printers.forEach(p => {
          this.editables[p.did] = false
        });
      });
    },

    toggleEditable(printer, editable) {
      this.editables[printer.did] = editable || !this.editables[printer.did];
      if (this.editables[printer.did]) {
        this.editablePrinter = {
          name: printer.name, shop_name: printer.shop_name, times: printer.times
        };
        printer.name += ' ';//NOTE: Otherwise el-table won't update itself.
        printer.name = printer.name.substring(0, printer.name.length - 1);
      }
      else {
        console.log('disabled editable', printer, this.editablePrinter);
        this.editablePrinter.name += ' ';//NOTE: Otherwise el-table won't update itself.
        this.editablePrinter.name = this.editablePrinter.name.substring(0, this.editablePrinter.name.length - 1);
      }
      // console.log(this.editables);
      
    },

    fetchShops(keyword) {
      axios.get(`${process.env.VUE_APP_APIHOST}/gaa/shops`)
      .then(response => {
        console.log(`fetchShops`, response.data);
        if (Array.isArray(response.data)) this.shops = response.data;
        else this.shops = response.data.shops;
      })
      .catch(err => {
        console.error(`Cannot fetch shops`, err);
      });
    },
    copyToShop(printer) {
      console.log(JSON.stringify(printer));
      axios.post(`${process.env.VUE_APP_APIHOST}/gaa/printers/${printer.did}/copy`)
      .then(response => {
        // console.log(`fetchShops`, response.data);
        // if (Array.isArray(response.data)) this.shops = response.data;
        // else this.shops = response.data.shops;
        this.fetchPrinters();
        console.log(response);
      })
      .catch(err => {
        console.error(`Cannot copy the printer`, err);
      });
    },
    suggestShops(keyword, cb) {//NOTE: For auto-completion
      let candidates = [];
      this.shops.forEach(shop => {
        if (shop.id == keyword)
          candidates.push({value: `${shop.id} - ${shop.name}`, shopId: shop.id});
        else if (shop.name && shop.name.toLowerCase().indexOf(keyword.toLowerCase()) > -1)
          candidates.push({value: `${shop.id} - ${shop.name}`, shopId: shop.id});
      });
      cb(candidates);
    },
    onShopSelectionUpdated(shop) {
      console.log(`onShopSelectionUpdated`, shop);
      this.selectedShopId = shop.shopId;
    },
    onShopSelectionTextChanged(v) {
      console.log(`onShopSelectionTextChanged`, v);
      if (!v || !v.length)
        this.selectedShopId = 0;
    },

    showInfo(printer) {
      this.dialogs.info.printer = printer;
      this.dialogs.info.show = true;
    },
    showSoundSetting(printer) {
      this.dialogs.sound.printer = printer;
      this.dialogs.sound.model.type = printer.voice_id;
      this.dialogs.sound.model.volume = printer.volume;
      this.dialogs.sound.show = true;
    },
    purgePrinterQueue(printer) {
      this.$confirm(`確定要清除印表機 ${printer.name} 的列印佇列？`, '警告', {
        confirmButtonText: '確定', cancelButtonText: '取消', type: 'warning'
      })
      .then(() => {
        purgePrinterQueue(printer.did)
        .then(response => {
          this.$message({
            type: 'success', message: `已清除列印佇列。（${printer.name}）`
          });
        })
        .catch(err => {
          this.$message.error(`無法清除，請稍後重試。`);
        });
      })
      .catch(err => {
        /* Cancelled. Do nothing. */
      });
    },
    createPrinter() {
      let printer = this.dialogs.create.model;
      createPrinter(printer)
      .then(response => {
        this.dialogs.create.show = false;
        this.fetchPrinters();
        this.$message({
          type: 'success', message: `印表機新增成功！（${printer.name}）`
        });
      })
      .catch(err => {
        this.dialogs.create.show = false;
        this.$message.error(`印表機新增失敗，請稍後重試。`);
      });
    },
    updatePrinter(printer) {
      printer.name = this.editablePrinter.name;
      printer.times = this.editablePrinter.times;

      let targetShop = this.shops.find(s => { return s.id === this.selectedShopId });
      if (targetShop) {
        printer.shop_id = targetShop.businessId;
        printer.shop_name = targetShop.name;
      }

      let requestPrinterUpdate = () => {
        let params = {
          name: printer.name, times: printer.times,
        };
        if (targetShop) {//Add optional binding parameters.
          params.shop_id = printer.shop_id;
          params.shop_name = printer.shop_name;
        }
        updatePrinter(printer.did, params)
        .then(response => {
          // this.fetchPrinters();
          this.toggleEditable(printer, false)
          this.$message({
            type: 'success', message: `印表機更新成功！（${printer.name}）`
          });
        })
        .catch(err => {
          this.toggleEditable(printer, false)
          this.$message.error(`印表機更新失敗，請稍後重試。`);
        });
      };

      if (!targetShop) {
        this.$confirm('此印表機的綁定狀態將維持不變，確定繼續嗎？', '沒有指定綁定店家', {
          confirmButtonText: 'OK', cancelButtonText: '取消', type: 'warning'
        })
        .then(() => {
          requestPrinterUpdate();
        })
        .catch(() => {
          console.warn(`update-printer aborted.`);
        });
      }
      else {
        requestPrinterUpdate();
      }
      
    },
    unbindPrinter(printer) {
      this.$confirm(`將要解除店家 ${printer.shop_name} 綁定之印表機 ${printer.name} ，確定執行嗎？`, '警告', {
        confirmButtonText: '確定', cancelButtonText: '取消', type: 'warning'
      })
      .then(() => {
        let shop_id = this.shops.find(s => {return s.name === printer.shop_name;}).businessId;
        if (!shop_id) {
          this.$message.error(`錯誤：${params.shop_name}`);
          this.toggleEditable(printer, false)
          return;
        }
        unbindPrinter(printer.did, shop_id)
        .then(response => {
          this.fetchPrinters();
          this.$message({
            type: 'success', message: `印表機 ${printer.name} 已與店家 ${printer.shop_name} 解除綁定。`
          });
        })
        .catch(err => {
          this.$message.error(`無法從店家 ${printer.shop_name} 解除綁定印表機 ${printer.name}，請稍後重試。`);
        });
      })
      .catch(() => { /* nothing to do? */ });
    },
    deletePrinter(printer) {
      this.$confirm(`將永久刪除印表機 ${printer.name} ，確定執行嗎？`, '警告', {
        confirmButtonText: '確定', cancelButtonText: '取消', type: 'warning'
      })
      .then(() => {
        deletePrinter(printer.did)
        .then(response => {
          this.fetchPrinters();
          this.$message({
            type: 'success', message: `印表機${printer.name}已刪除。`
          });
        })
        .catch(err => {
          this.$message.error(`無法刪除印表機${printer.name}，請稍後重試。`);
        });
      })
      .catch(() => { /* nothing to do? */ });
    },

    setSound(command) {
      this.dialogs.sound.show = false;
      setPrinterSound(this.dialogs.sound.printer.did, this.dialogs.sound.model)
      .then(response => {
        this.dialogs.sound.printer.voice_id = this.dialogs.sound.model.type;
        this.dialogs.sound.printer.volume = this.dialogs.sound.model.volume;
        this.$message({
          type: 'success', message: `印表機提示音效設定成功！（${this.dialogs.sound.printer.name}）`
        });
      })
      .catch(err => {
        this.$message.error(`印表機提示音效設定失敗，請稍後重試。`);
      });
    }

  },

  data() {
    return {
      printers: [],
      editables: {},
      editablePrinter: {},
      selectedShopId: 0,

      shops: [],
      filteredShops: [],
      isLoadingShops: false,

      dialogs: {
        info: {
          show: false,
          printer: {}
        },
        create: {
          show: false, model: {
            name: '', sn: '', secret: '', server: 'iiot', times: 1
          }
        },
        sound: {
          show: false, printer: {},
          model: {
            type: 0, volume: 'mute'
          }
        }
      },

      filters: [
        {
          prop: ['sn', 'name', 'shop_name'], value: ''
        }
      ]
    }
  },

  computed: {
    infoTable() {
      let ret = [];
      ret.push({key: '序號', val: this.dialogs.info.printer.sn});
      ret.push({key: '裝置ID', val: this.dialogs.info.printer.did});
      ret.push({key: '名稱', val: this.dialogs.info.printer.name});
      ret.push({key: '密鑰', val: this.dialogs.info.printer.secret});
      ret.push({key: '伺服器', val: this.dialogs.info.printer.server});
      ret.push({key: '列印次數', val: this.dialogs.info.printer.times});
      ret.push({key: '更新時間', val: this.dialogs.info.printer.updated_at});
      ret.push({key: '綁定店家', val: this.dialogs.info.printer.shop_name, width: 320});
      ret.push({key: '綁定時間', val: this.dialogs.info.printer.bound_at});
      return ret;
    }
  }
}
</script>

<style scoped>
.el-dropdown {
  margin: 0 9px;
}
</style>

<style>
.shop-select-autocomplete {
  width: 360px !important;
}
</style>